<template>
  <div @leave-cell="onLeave"
       class="statistics-table">
    <div class="statistics-table__content">
      <StatisticsPageTableHead :cells="cells"
                               :mainCells="mainCells"
                               :currentSort="currentSort"
                               @enter-cell="onEnter"
                               @leave-cell="onLeave"
                               @sort="$emit('sort', $event)"/>

      <div class="statistics-table__body">
        <StatisticsPageTableBodyRow v-for="(row, index) in rows"
                                    :key="row.partner.id + '-' + index"
                                    :row="row"
                                    :cells="cells"
                                    :mainCells="mainCells"
                                    :hoverCell="currentHoverCell"
                                    :toLastRow="rows.length < 2 ? 1 : rows.length - 1 - index"
                                    :isOpen="index === currentOpenRow"
                                    @enter-cell="onEnter"
                                    @leave-cell="onLeave"
                                    @open="currentOpenRow = index"
                                    @close="currentOpenRow = null"/>
      </div>

      <StatisticsPageTableFooter :total="total"
                                 :mainCells="mainCells"
                                 :hoverCell="currentHoverCell"/>
    </div>
  </div>
</template>

<script>
  import StatisticsPageTableHead from './StatisticsPageTableHead'
  import StatisticsPageTableBodyRow from './StatisticsPageTableBodyRow'
  import StatisticsPageTableFooter from './StatisticsPageTableFooter'

  export default {
    name: 'StatisticsPageTable',
    components: {
      StatisticsPageTableHead,
      StatisticsPageTableBodyRow,
      StatisticsPageTableFooter,
    },
    inject: [
      'PARTNER_CELL_KEY'
    ],
    props: {
      cells: Object,
      rows: Array,
      total: Object,
      currentSort: Object,
    },
    data() {
      return {
        currentHoverCell: null,
        currentOpenRow: null
      }
    },
    computed: {
      mainCells() {
        const r = Object.assign({}, this.cells)
        delete r[this.PARTNER_CELL_KEY]
        return r
      }
    },
    methods: {
      // uniqueId,

      onEnter(index) {
        this.currentHoverCell = index
      },
      onLeave(index) {
        if (this.currentHoverCell === index) {
          this.currentHoverCell = null
        }
      },
    }
  }
</script>

<style lang="less">

</style>
